import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Badge } from '@openng/optimus-ui/badge';

@Component({
    selector: 'app-folder',
    templateUrl: './folder.component.html',
    styleUrl: './folder.component.scss',
    imports: [
        Badge,
    ],
})
export class FolderComponent {
    @Input() name!: string;
    @Input() count: string | number = 0;
    @Input() selected: boolean = false;
    @Output() selectedChange = new EventEmitter<boolean>();
}
